<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <DIV
    class="form-row"
  >
    <DIV
      class="col-3"
      v-if="loaded"
    >
      <ItpFormInput
        mask="number"
        unmask="typed"
        scale="2"
        name="exchange_rate_value"
        v-model="item.value"
        :readonly="readonly"
        :placeholder="'Rate'|pgettext('ExchangeRateFieldset')"
        @blur="evh_6466705138206980_blur($event, {})"
      >
      </ItpFormInput>
    </DIV>
    <DIV
      class="col-4"
      v-if="loaded"
    >
      <ItpFormDatetime
        name="exchange_rate_date"
        v-model="item.date"
        :readonly="readonly"
        :placeholder="'Date'|pgettext('ExchangeRateFieldset')"
        @blur="evh_3943151158818434_blur($event, {})"
      >
      </ItpFormDatetime>
    </DIV>
    <DIV
      class="col-5"
      v-if="loaded"
    >
      <ItpFormSelect
        name="exchange_rate_source"
        v-model="item.source"
        :options="exchangeRateSources"
        :readonly="readonly"
        :placeholder="'Provider'|pgettext('ExchangeRateFieldset')"
        valueField="value"
        textField="name"
        @blur="evh_4207795475682514_blur($event, {})"
      >
      </ItpFormSelect>
    </DIV>
  </DIV>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class ExchangeRateFieldset extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  getInternalItem(...args: any[]) {
    if (!this.__item) {
      this.__item = { value: null, date: null, source: null };
    }
    return this.__item;
  }

  syncExchangeRate(...args: any[]) {
    const v = this.internalItem
    const value = v.value == null ? null : _.clone(v);
    this.$emit('input', value.value);
    console.log('$emit.input', value);
  }

  @Prop({
    required: true,
  })
  value!: any;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  labelAlign!: any;
  internalItem!: any;

  async $$load_internalItem() {
    return this.getInternalItem()
  }

  exchangeRateSources!: any;

  async $$load_exchangeRateSources() {
    return this.$app.repo.get('ui_metadata', { path: 'exchange_rate_source_options' })
  }

  ux!: any;
  dataMembers = ['labelAlign', 'internalItem', 'exchangeRateSources', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelAlign: "right",
        internalItem: null,
        exchangeRateSources: null,
        ux: null,
      },
    }
  }

  get item() {
    if (this.loaded) {

      return (console.log('computed', this.value), _.assign(this.internalItem, this.value))
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_6466705138206980_script_3102_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6466705138206980_script_3102, alias=undefined
    this.syncExchangeRate()
  }

  async act_6466705138206980_script_3102_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6466705138206980_script_3102, alias=undefined
    return {
      value: () => this.act_6466705138206980_script_3102_getActionArgs_value($event),
    }
  }

  async evh_6466705138206980_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_blur.executeFromDOM(this, event, scope);
  }

  async act_3943151158818434_script_3104_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3943151158818434_script_3104, alias=undefined
    this.syncExchangeRate()
  }

  async act_3943151158818434_script_3104_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3943151158818434_script_3104, alias=undefined
    return {
      value: () => this.act_3943151158818434_script_3104_getActionArgs_value($event),
    }
  }

  async evh_3943151158818434_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3943151158818434_blur.executeFromDOM(this, event, scope);
  }

  async act_4207795475682514_script_3106_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_4207795475682514_script_3106, alias=undefined
    this.syncExchangeRate()
  }

  async act_4207795475682514_script_3106_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_4207795475682514_script_3106, alias=undefined
    return {
      value: () => this.act_4207795475682514_script_3106_getActionArgs_value($event),
    }
  }

  async evh_4207795475682514_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4207795475682514_blur.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_3100: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_3099: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_6466705138206980_script_3102: actions.ScriptAction;
    evh_6466705138206980_blur_3101: actions.EventHandlerImpl;
    evh_6466705138206980_blur: actions.EventHandlerGroup;
    act_3943151158818434_script_3104: actions.ScriptAction;
    evh_3943151158818434_blur_3103: actions.EventHandlerImpl;
    evh_3943151158818434_blur: actions.EventHandlerGroup;
    act_4207795475682514_script_3106: actions.ScriptAction;
    evh_4207795475682514_blur_3105: actions.EventHandlerImpl;
    evh_4207795475682514_blur: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_3100 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_3099 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_3100,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_3099],
      }
    );
    const act_6466705138206980_script_3102 = new actions.ScriptAction(
      {
        actionArgs: this.act_6466705138206980_script_3102_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_blur_3101 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_script_3102,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_6466705138206980_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_blur_3101],
      }
    );
    const act_3943151158818434_script_3104 = new actions.ScriptAction(
      {
        actionArgs: this.act_3943151158818434_script_3104_getActionArgs,
        events: [],
      }
    );
    const evh_3943151158818434_blur_3103 = new actions.EventHandlerImpl(
      {
        action: act_3943151158818434_script_3104,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_3943151158818434_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_3943151158818434_blur_3103],
      }
    );
    const act_4207795475682514_script_3106 = new actions.ScriptAction(
      {
        actionArgs: this.act_4207795475682514_script_3106_getActionArgs,
        events: [],
      }
    );
    const evh_4207795475682514_blur_3105 = new actions.EventHandlerImpl(
      {
        action: act_4207795475682514_script_3106,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_4207795475682514_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_4207795475682514_blur_3105],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_3100,
      evh_7315092382398562_reload_3099,
      evh_7315092382398562_reload,
      act_6466705138206980_script_3102,
      evh_6466705138206980_blur_3101,
      evh_6466705138206980_blur,
      act_3943151158818434_script_3104,
      evh_3943151158818434_blur_3103,
      evh_3943151158818434_blur,
      act_4207795475682514_script_3106,
      evh_4207795475682514_blur_3105,
      evh_4207795475682514_blur,
    }
  }
}

Vue.component("ExchangeRateFieldset", ExchangeRateFieldset);

</script>